import { render, staticRenderFns } from "./ActivitiesNew.vue?vue&type=template&id=23394a6d&scoped=true"
import script from "./ActivitiesNew.vue?vue&type=script&lang=ts"
export * from "./ActivitiesNew.vue?vue&type=script&lang=ts"
import style0 from "./ActivitiesNew.vue?vue&type=style&index=0&id=23394a6d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23394a6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23394a6d')) {
      api.createRecord('23394a6d', component.options)
    } else {
      api.reload('23394a6d', component.options)
    }
    module.hot.accept("./ActivitiesNew.vue?vue&type=template&id=23394a6d&scoped=true", function () {
      api.rerender('23394a6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/ActivitiesNew.vue"
export default component.exports